import { Component, OnInit, EventEmitter } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { CoinEventsService } from '../../../_services/coinevents.service';
import { UppercaseDirective } from '../../../_directives/uppercase.directive';

@Component({
    selector: 'app-edit-coin-events',
    templateUrl: './edit-coin-events.component.html',
    styleUrls: ['./edit-coin-events.component.css']
})
export class EditCoinEventsComponent extends DialogComponent<null, boolean> implements OnInit {

    model: any = {};
    loading = false;
    message: string;
    returnUrl: string;
    coinId: string;
    coinName: string;
    focusEventEmitter = new EventEmitter<boolean>();

    constructor(
        dialogService: DialogService, 
        private coinEventsService: CoinEventsService
    ) {
        super(dialogService);
    }

    ngOnInit() {
        this.loading = true;
        this.model.coinname = this.coinName;

        //use service to get coin id
        this.coinEventsService.get(this.coinId).subscribe(data => {
            this.model.coinname = data.coin_name;
            this.model.isActive = data.is_active;
        }, error => {
            
        }, () => {
            this.loading = false;
        });
    }

    ngAfterViewInit() {
        this.focusEventEmitter.emit(true);
    }

    edit() {
        this.loading = true;
        this.message = '';
        this.model.id = this.coinId;

        //use service to edit model
        this.coinEventsService.edit(this.model).subscribe(data => {
            if (data.error) {
                this.message = data.message;
            } else {
                this.close();
                this.result = true;
            }
        }, error => {
            this.message = error.json().message;
            this.loading = false;
        }, () => {
            this.loading = false;
        })
    }
}




// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/coinevents/edit-coin-events/edit-coin-events.component.ts